/**
 * Banner de error.
 *
 * Nada muere en silencio tampoco en la pantalla: si la carga fallo, se dice que
 * paso y se ofrece reintentar. Cuando el error es un desajuste de contrato se
 * listan los issues de Zod, porque ese error lo arregla quien esta mirando.
 */
import type { ReactElement } from 'react';
import { ContractValidationError, describeError } from '../api/errors';

export interface ErrorBannerProps {
  readonly error: unknown;
  readonly onRetry?: () => void;
}

export function ErrorBanner({ error, onRetry }: ErrorBannerProps): ReactElement | null {
  if (error === null || error === undefined) {
    return null;
  }

  return (
    <div className="banner banner--error" role="alert">
      <div className="banner__title">{describeError(error)}</div>
      {error instanceof ContractValidationError && error.issues.length > 0 ? (
        <ul className="banner__issues">
          {error.issues.slice(0, 8).map((issue, index) => (
            <li key={`${issue.path.join('.')}-${index}`}>
              {issue.path.length === 0 ? '(raíz)' : issue.path.join('.')}: {issue.message}
            </li>
          ))}
        </ul>
      ) : null}
      {onRetry ? (
        <div className="banner__actions">
          <button type="button" className="button button--sm" onClick={onRetry}>
            Reintentar
          </button>
        </div>
      ) : null}
    </div>
  );
}
